import React from "react";

const Contact = () => {
  return (
    <section id="contact" className="py-28 bg-white">
      <div className="container mx-auto px-6 max-w-md md:max-w-xl">
        <h2 className="text-5xl font-extrabold text-center text-gray-900 mb-14 tracking-tight">
          Contact Us
        </h2>
        <form
          className="bg-gray-50 p-12 rounded-3xl shadow-lg space-y-8"
          aria-label="Contact form"
        >
          <label htmlFor="name" className="sr-only">
            Your Name
          </label>
          <input
            id="name"
            type="text"
            placeholder="Your Name"
            className="w-full px-6 py-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-4 focus:ring-indigo-400 focus:border-indigo-600 transition placeholder-gray-400"
            aria-required="true"
            required
          />

          <label htmlFor="email" className="sr-only">
            Your Email
          </label>
          <input
            id="email"
            type="email"
            placeholder="Your Email"
            className="w-full px-6 py-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-4 focus:ring-indigo-400 focus:border-indigo-600 transition placeholder-gray-400"
            aria-required="true"
            required
          />

          <label htmlFor="message" className="sr-only">
            Your Message
          </label>
          <textarea
            id="message"
            placeholder="Your Message"
            rows="6"
            className="w-full px-6 py-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-4 focus:ring-indigo-400 focus:border-indigo-600 resize-none transition placeholder-gray-400"
            aria-required="true"
            required
          ></textarea>

          <button
            type="submit"
            className="w-full bg-indigo-600 text-white py-4 rounded-xl font-semibold text-lg hover:bg-indigo-700 focus:bg-indigo-700 focus:outline-none focus:ring-4 focus:ring-indigo-500 focus:ring-offset-2 transition"
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
